module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "info-wrap"
  }, [_c('input', {
    ref: "file",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file"
    },
    on: {
      "change": _vm.sendavatar
    }
  }), _c('div', {
    staticClass: "camera",
    on: {
      "click": _vm.sendfile
    }
  }, [_c('svg', {
    staticClass: "icon",
    staticStyle: {
      "font-size": "2.5rem"
    },
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#icon-xiangji"
    }
  })])]), _c('div', {
    staticClass: "name"
  }, [_c('label', {
    attrs: {
      "for": "name"
    }
  }, [_vm._v(" 姓名")]), _c('input', {
    attrs: {
      "id": "name",
      "placeholder": "请输入手机号码"
    }
  }), _c('div', {
    staticClass: "clear"
  }, [_c('svg', {
    staticClass: "icon",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('use', {
    staticStyle: {
      "color": "#999"
    },
    attrs: {
      "xlink:href": "#icon-guanbi"
    }
  })])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2bae00aa","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/setInfo.vue
// module id = 112
// module chunks = 0